import * as React from "react";

const IconAlert: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M0,5 L0,11 L5,16 L11,16 L16,11 L16,5 L11,0 L5,0 L0,5 Z M11.0593748,6 L10.5281248,6.53125 L9.05937481,8 L10.5281248,9.46875 L11.0593748,10 L10,11.0593748 L9.46875,10.5281248 L8,9.05937481 L6.53125,10.5281248 L6,11.0593748 L4.94062519,10 L5.47187519,9.46875 L6.94062519,8 L5.47187519,6.53125 L4.94062519,6 L6,4.94062519 L6.53125,5.47187519 L8,6.94062519 L9.46875,5.47187519 L10,4.94062519 L11.0593748,6 Z"
            />
        </svg>
    );
};
export default React.memo(IconAlert);
